<template>
  <div class="body-page">
    <nav class="navbar navbar-inverse">
      <div class="container">
        <div class="navbar-header">
          <div class="navbar-logo">
            <a href="/"><img src="../assets/Logo.svg"/></a>
          </div>
        </div>
        <div id="navbar" class="collapse navbar-collapse">
          <ul class="nav navbar-nav navbar-right">
            <li v-if="!!loggedInUser">
              <a href v-on:click.prevent="logout()">ÚTSKRÁ ({{ loggedInUser.ssn }})</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div class="container">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import auth from '../services/auth'
import router from '../router'

export default {
  name: 'page',
  data() {
    return {
      loggedInUser: null
    }
  },
  methods: {
    logout() {
      auth.logout()
      router.push('/')
    }
  },
  created() {
    this.loggedInUser = auth.getPayload()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
